/**
 * Download time series as CSV (UTF-8 with BOM for Excel Persian support).
 */
export function downloadTimeSeriesCsv(rows, filename = "time-series.csv") {
  if (!rows?.length) return;

  const header = "date,value";
  const lines = rows.map((r) => {
    const date = String(r.label ?? r.date ?? "").replace(/"/g, '""');
    const value = r.value ?? "";
    return `"${date}",${value}`;
  });
  const csv = `\uFEFF${header}\n${lines.join("\n")}`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
